export function wrapWithMaxWidth(content, maxWidth = 300) {
  const startTag = `<span style='max-width: ${maxWidth}px; display:block; white-space: normal; word-wrap:break-word;'>`;
  const endTag = '</span>';

  return `${startTag}${content}${endTag}`;
}
